export const nameByKind = kind => {
  return i18n.t(`block_kinds.${kind}`);
};

export default {
  nameByKind
}
